<!-- 页面内容 -->
<!-- About us -->
<template>
    <!-- container -->
    <div class='content'>
        <div class="container cont">
            <div class="contV">
                <div class="T1">All Brands</div>
                <div class="topA">
                    <div class="tabV" v-for="(item, index) in List" :key="index" @click="goTab(index, item.brandId)">
                        <img class="logo" :src="item.logo" alt="" />
                        <div class="name">{{ item.name }}</div>
                    </div>
                </div>
                <!-- <div style="margin-top: 40px;" v-loading="loading">
                    <good-list :goodList="FlashList" v-if="FlashList.length > 0" />
                </div> -->
            </div>



        </div>
    </div>
</template>

<script>
// import GoodList from '@/components/GoodList/GoodList.vue'
export default {
    // components: { GoodList },
    data() {
        return {
            loading: false,
            List: [],
            FlashList: [],
        }
    },
    mounted() {
        this.getAboutApi();
    },
    methods: {
        goTab(index, id) {
            // console.warn(index, id)
            this.$router.push({
                path: "BrandsLIst",
                query: {
                    ids: id,
                    idx: index
                }
            })
            // this.listFlashApi(id)
        },
        // 品牌下的商品
        async listFlashApi(id) {
            this.loading = true;
            try {
                const res = await this.$get('system/goods/list', {
                    brandId: id
                });
                this.loading = false;
                this.FlashList = this.goodListAttrFormat(res.rows || []);
            } catch (error) {
            }
        },
        // 查询品牌 
        async getAboutApi() {
            try {
                const res = await this.$get('system/brand/list');
                this.List = res.rows || [];
                // this.goTab(this.List[0].brandId)
                // console.warn(res, "查询品牌")
            } catch (error) {
            }
        },
        goForm() {
            console.warn('+++++++++')
            this.$router.push({
                path: "customizationFrom"
            })
        }
    },
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>